<template>
	<div id="secondaryHome">
		<div class="pageList clearfloat" v-show="!secondary">
			<!-- 页面列表 -->
			<el-card class="pageCard" v-if="!secondary">
				<i class="el-icon-plus addPageBtn" @click="hanldeAddPages"></i>
			</el-card>
			<!-- 新增次级页面 -->
			<el-card
				shadow="hover"
				v-for="(item, index) in computedPages"
				:key="index"
				:class="cardChose == index ? 'pageCard' : 'innerPageCard'"
				@click.native="handleChoseCard(index)"
			>
				<div class="cardHeader" slot="header">
					<p class="innerPageTitle clearfloat" v-if="item.inner">
						<span class="right cardMark" v-if="cardChose == index"
							>内置页面</span
						>
						<span class="left cardMark">{{
							$utils.escapePageName(item.type)
						}}</span>
					</p>
					<p class="innerPageTitle clearfloat" v-else>
						<span
							class="right cardMark"
							v-if="cardChose == index"
							>{{ $utils.escapePageName(item.type) }}</span
						>
						<span class="left cardMark">{{ item.nvgName }}</span>
					</p>
				</div>
				<div class="clearfloat" v-show="cardChose == index">
					<!-- 自定义 -->
					<el-link
						class="right"
						v-if="!item.inner"
						type="danger"
						@click="handleDelete(item)"
					>
						删除
					</el-link>
					<el-link
						class="right marginR10"
						v-if="!item.inner"
						type="primary"
						@click="handleEdit(item)"
					>
						编辑
					</el-link>
				</div>
			</el-card>
		</div>
		<!-- 自定义页面 -->
		<el-card v-if="secondary" class="marginT20">
			<p class="secondaryHeader clearfloat" slot="header">
				<span class="left">自定义页面</span>
				<el-link
					class="right"
					icon="el-icon-close"
					:underline="false"
					@click="handleCloseSecondary"
				></el-link>
			</p>
			<Subpage
				ref="secondary"
				class="marginT20"
				:pages="pages"
				:propertes="propertes"
				:pageInfo="pageInfo"
			></Subpage>
			<div class="clearfloat">
				<el-button
					type="primary"
					class="saveBtn right"
					@click="handleSubmit"
				>
					保存
				</el-button>
			</div>
		</el-card>
	</div>
</template>

<script>
import Subpage from "./Subpage";
export default {
	props: ["productId", "pages", "propertes", "templateId"],
	components: {
		Subpage,
	},
	data() {
		return {
			cardChose: null,
			dialogVisible: false,
			secondary: false,
			pageInfo: {},
		};
	},
	computed: {
		computedPages() {
			return this.pages.filter((el) => {
				// 排除20 滤芯管理, 22 模式选择，23 定时
				return el.type != 22 && el.type != 23 && el.type != 20
			})
		},
	},
	methods: {
		// 提交表单
		handleSubmit: function () {
			let obj = this.$refs.secondary.handleSubmit();
			if (obj != false) {
				obj.productId = this.productId;
				obj.templateTypeId = this.templateId;
				obj.inner = obj.inner ? true : false;
			let ajax = obj.id
				? this.$http.secondPageEdit
				: this.$http.secondPageAdd;
				ajax(obj).then((res) => {
					if (res.data.success) {
						this.$parent.$parent.$parent.handleGetPages();
						this.secondary = false;
						this.pageInfo = {};
					}
				});
			}
		},
		// 编辑自定义
		handleEdit: function (item) {
			this.pageInfo = item;
			this.$nextTick(() => {
				this.secondary = true;
			});
		},
		// 删除次级页面
		handleDelete: function (item) {
			let msg = "确认删除此次级页面吗?";
			this.$confirm(msg, "提示", {
				confirmButtonText: "确认",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$http.secondaryPageDelete(item.id).then((res) => {
						if (res.data.success) {
							this.$parent.$parent.$parent.handleGetPages();
						}
					});
				})
				.catch(() => {});
		},
		// 新增次级页面
		hanldeAddPages: function () {
			this.secondary = true;
			this.cardChose = null;
		},
		// 关闭次级页面
		handleCloseSecondary: function () {
			this.$confirm(
				"是否确认关闭，此操作将清空所有未保存内容？",
				"提示",
				{
					confirmButtonText: "确认",
					cancelButtonText: "取消",
					type: "warning",
				}
			).then(() => {
				this.$set(this, "pageInfo", {});
				this.secondary = false;
			});
		},
		// 选择卡片
		handleChoseCard: function (idx) {
			this.cardChose = idx;
		},
	},
};
</script>

<style scoped>
.pageList {
	vertical-align: top;
}
.pageCard {
	display: inline-block;
	width: 300px;
	height: 150px;
	margin-right: 10px;
}
.innerPageCard {
	cursor: pointer;
	display: inline-block;
	width: 150px;
	height: 150px;
	margin-right: 10px;
}
.addPageBtn {
	display: block;
	text-align: center;
	line-height: 110px;
	font-size: 50px;
	color: #ddd;
}

.addPageBtn:hover {
	color: #999;
	cursor: pointer;
}
.innerPageTitle {
	font-size: 14px;
	text-align: center;
}
.cardHeader {
	height: 70px;
}
.saveBtn {
	width: 100%;
	height: 50px;
	margin-top: 20px;
}

.secondaryHeader {
	height: 22px;
	vertical-align: top;
}
.secondaryHeader .right {
	font-size: 30px;
	line-height: 50px;
}
.cardMark {
	font-weight: 500;
}
</style>